import React from 'react';

const YesCardResetPage = ({ children, hint, title, subTitle }) => (
  <div className="yes-card-reset-component">
    <div className="yes-card-reset-component__header">
      {hint && <p className="hint">{hint}</p>}
      <h2 className="pts-b-white-30">{title}</h2>
      {subTitle ? (
        <p className="sub-title">{subTitle}</p>
      ) : (
        <p className="sub-title"> </p>
      )}
    </div>
    <div className="yes-card-reset-component__body">{children}</div>
  </div>
);

export default YesCardResetPage;